import styled from 'styled-components';

export const Container = styled.header`
  background-color: ${({ color, theme }) => color ?? theme.colors.PRIMARY};

  height: 6.7rem;
  width: 100%;
`;
